import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { consumeHandoffToken } from "./components/auth/tokenHandoff";
import { HandoffGate } from "./components/auth/HandoffGate";

// Before the first render, so a token handed over from the web sign-up site is already
// stored when <RequireAuth> and BrowserRouter read the session and the URL. A token that
// didn't come from a Bits site is held back instead, for <HandoffGate> to confirm.
consumeHandoffToken();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <HandoffGate>
        <App />
      </HandoffGate>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
